import { createContext, useContext, useState, useCallback } from "react";

const USD_RATE = 1.08; // taux fixe €→$ (affichage uniquement)
const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(() => {
    try { return localStorage.getItem("coccon_currency") || "eur"; } catch { return "eur"; }
  });
  const setCurrency = useCallback((c) => {
    setCurrencyState(c);
    try { localStorage.setItem("coccon_currency", c); } catch { /* ignore */ }
  }, []);
  const rate = currency === "usd" ? USD_RATE : 1;
  const symbol = currency === "usd" ? "$" : "€";
  const convert = useCallback((eur) => Math.round(Number(eur || 0) * rate), [rate]);
  const format = useCallback((eur) => `${convert(eur)} ${symbol}`, [convert, symbol]);
  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, rate, symbol, convert, format }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () =>
  useContext(CurrencyContext) || {
    currency: "eur", setCurrency: () => {}, rate: 1, symbol: "€",
    convert: (e) => Math.round(Number(e || 0)), format: (e) => `${Math.round(Number(e || 0))} €`,
  };
